import _ from 'lodash'

export const _matchAccessLevels = {
  team: 'team',
  sport: 'sport',
  school: 'school',
  admin: 'admin'
}

export const _matchResultTypes = {
  normal: 'normal',
  realtime: 'realtime',
  matchDay: 'matchDay'
}

const rts = {
  handleSet_latestSeason: 'handleSet_latestSeason',
  handleSet_matchAllowances: 'handleSet_matchAllowances',
  handleSet_matchDataUpdates: 'handleSet_matchDataUpdates',
  handleSet_matchDayMatchData: 'handleSet_matchDayMatchData',
  handleSet_realtimeMatchData: 'handleSet_realtimeMatchData',
  handleSet_rtMatch: 'handleSet_rtMatch',
  handleSet_trueMatch: 'handleSet_trueMatch',
  handleShow_matchScoreTable: 'handleShow_matchScoreTable',
  handleShow_scoreEdit: 'handleShow_scoreEdit',
  handleShow_scoreEdit: 'handleShow_scoreEdit',
}

export const matchDisplayTypes = {
  matchOptions: 'matchOptions',
  realtimeScoring: 'realtimeScoring',
}

export const sportsMatchReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleShow_scoreEdit:
      return { ...state, match_edit: _.cloneDeep(action.match), showMatchScoreTable: false, editFromRt: action.editFromRt }

    case rts.handleSet_latestSeason:
      return { ...state, latestSeason: action.latestSeason }

    case rts.handleSet_rtMatch:
      const { match_rt } = action
      if (match_rt && !match_rt?._results?.setNumber) { match_rt._results.setNumber = 1 }
      return { ...state, match_rt: action.match_rt }

    case rts.handleSet_realtimeMatchData:
      return { ...state, matchData_rt: action.matchData_rt }

    case rts.handleSet_matchDayMatchData:
      return { ...state, matchDayMatchData: action.matchDayMatchData }

    case rts.handleSet_matchAllowances:
      const { matchAllows } = action ?? {}
      const { full, scores, scores_p, edit, matchAccessLevel } = matchAllows ?? {}
      const _matchAllows = {
        full: full ? true : false,
        edit: full || edit ? true : false,
        scores_p: scores_p ? true : false,
        scores: full || edit || scores ? true : false,
        matchAccessLevel
      }
      return { ...state, matchAllows: _matchAllows }

    case rts.handleSet_matchDataUpdates:
      const _mpdu = _.cloneDeep(action.matchDataUpdates)
      Object.keys(_mpdu).forEach(k => {
        delete _mpdu[k].
          _existingInfo

      })
      return { ...state, matchDataUpdates: _mpdu }

    case rts.handleSet_trueMatch:
      return { ...state, match_true: action.match_true }

    case rts.handleShow_matchScoreTable:
      return { ...state, scoresOn: false, showMatchScoreTable: !state.showMatchScoreTable }

    default:
      return { ...state }
  }
}

export const sportsMatchHandlers = (dispatch) => {
  return {
    handleSet_latestSeason: (latestSeason) => { dispatch({ type: rts.handleSet_latestSeason, latestSeason }) },
    handleSet_matchAllowances: (matchAllows) => { dispatch({ type: rts.handleSet_matchAllowances, matchAllows }) },
    handleSet_matchDataUpdates: (matchDataUpdates) => { dispatch({ type: rts.handleSet_matchDataUpdates, matchDataUpdates }) },
    handleSet_rtMatch: (match_rt) => { dispatch({ type: rts.handleSet_rtMatch, match_rt }) },
    handleSet_matchDayMatchData: (matchDayMatchData) => { dispatch({ type: rts.handleSet_matchDayMatchData, matchDayMatchData }) },
    handleSet_realtimeMatchData: (matchData_rt) => { dispatch({ type: rts.handleSet_realtimeMatchData, matchData_rt }) },
    handleSet_trueMatch: (match_true, match_dy) => { dispatch({ type: rts.handleSet_trueMatch, dispatch, match_true, match_dy }) },
    handleShow_matchScoreTable: (match) => { dispatch({ type: rts.handleShow_matchScoreTable, match }) },
    handleShow_scoreEdit: (match, editFromRt) => { dispatch({ type: rts.handleShow_scoreEdit, match, editFromRt }) },
  }
}

export const sportsMatchInitialState = (init_state) => {
  return { ...init_state, currentAthletes: {}, matchAllows: { scores: false, edit: false, full: false } }
};
